export default __webpack_public_path__ + "static/media/tokenImageBelobank.f20d86e4.svg";